import { useEffect, useRef, useState } from "react";

interface CoordinateInputProps {
  value: number;
  onChange: (next: number) => void;
  className?: string;
  ariaLabel?: string;
  placeholder?: string;
}

export function CoordinateInput({
  value,
  onChange,
  className,
  ariaLabel,
  placeholder,
}: CoordinateInputProps) {
  const [draft, setDraft] = useState(String(value));
  const focusedRef = useRef(false);

  useEffect(() => {
    if (!focusedRef.current) setDraft(String(value));
  }, [value]);

  return (
    <input
      type="text"
      inputMode="decimal"
      value={draft}
      aria-label={ariaLabel}
      placeholder={placeholder}
      onFocus={() => {
        focusedRef.current = true;
      }}
      onBlur={() => {
        focusedRef.current = false;
        setDraft(String(value));
      }}
      onChange={(e) => {
        const raw = e.target.value;
        setDraft(raw);
        const parsed = parseFloat(raw.replace(",", "."));
        if (Number.isFinite(parsed)) onChange(parsed);
      }}
      className={className}
    />
  );
}
